import { GitHub, LinkedIn, Email, LightMode, DarkMode } from '@mui/icons-material';
import { Box, Tooltip, IconButton, Link } from '@mui/material';
import CopyEmailWrapper from '../CopyEmailWrapper';

interface NavBarToolsProps {
  toggleTheme: () => void;
  isDarkMode: boolean;
}

const NavBarTools = ({ toggleTheme, isDarkMode }: NavBarToolsProps) => (
  <Box display='flex' alignItems='center' gap={1.5}>
    <Tooltip title='GitHub'>
      <IconButton
        component={Link}
        href='https://github.com/albertjlay'
        target='_blank'
        rel='noopener noreferrer'
      >
        <GitHub color='primary' />
      </IconButton>
    </Tooltip>

    <Tooltip title='LinkedIn'>
      <IconButton
        component={Link}
        href='https://linkedin.com/in/albertjlay'
        target='_blank'
        rel='noopener noreferrer'
      >
        <LinkedIn color='primary' />
      </IconButton>
    </Tooltip>

    <Tooltip title='Email'>
      <IconButton
        component={Link}
        href='mailto:albertjlay@gmail.com'
        target='_blank'
        rel='noopener noreferrer'
      >
        <Email color='primary' />
      </IconButton>
    </Tooltip>

    {/* <Tooltip title={isDarkMode ? 'Light Mode' : 'Dark Mode'}>
      <IconButton color='primary' onClick={toggleTheme}>
        {isDarkMode ? <LightMode /> : <DarkMode />}
      </IconButton>
    </Tooltip> */}
  </Box>
);

export default NavBarTools;
